import { SEOFAQPage } from '../../types'
import { makeId } from '../utils'

export interface SEOFAQInput {
  question: string
  answer: string
}

export const getFAQ = (faqItems: SEOFAQInput[], pageUrl: string): SEOFAQPage => ({
  '@type': 'FAQPage',
  '@id': makeId(pageUrl, 'faq'),
  mainEntity: faqItems.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  })),
})
